import Haalo from './components/Haalo'
import Video from './components/Video';
import Questions from './components/Questions';
import Results from './components/Results';
import Application from './components/Application';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';

function App() {
  return (
    <div className='App'>
      <Router>
        <Routes>
          <Route path="/" element={<Application />} />
          <Route path="/video" element={<Video />} />
          <Route path="/haalo" element={<Haalo />} />
          <Route path="/test" element={<Questions />} />
          <Route path="/results" element={<Results />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;